export const Star = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.23418 4.38299L12.1872 4.66631C13.2148 4.76489 13.5299 5.76861 12.7364 6.42804L10.4245 8.34948L11.2828 11.4797C11.5646 12.5076 10.6902 13.1299 9.81434 12.5113L7.00521 10.527L4.19608 12.5113C3.32378 13.1274 2.44575 12.5078 2.72764 11.4797L3.5859 8.34948L1.27399 6.42804C0.477216 5.76584 0.791105 4.76534 1.82304 4.66631L4.77555 4.38299L6.07635 1.3839C6.48371 0.444699 7.52696 0.44517 7.93398 1.38399L9.23418 4.38299Z"
      fill="currentColor"
    />
  </svg>
);
